class Legislacao {
    static get $inject() {
        return ['gql']
    }

    constructor(gql) {
        this.gql = gql
    }

    async listTiposDestinacao() {
        const query = gql`
            query TiposDestinacao {
                tiposDestinacao {
                    codigo
                    descricao
                }
            }
        `

        const { tiposDestinacao } = await this.gql.query(query)
        
        return tiposDestinacao
    }
}

angular.module("eficienciaFiscalModule").service("Legislacao", Legislacao)
